import { themeVariables } from "Components/theme";
let draggingNode = null;
export const onDragStart = (e) => {
    draggingNode = e.currentTarget.cloneNode(true);
    if (draggingNode) {
        draggingNode.style.backgroundColor = themeVariables["navbar-bg"];
        draggingNode.style.color = themeVariables["navbar-link-color"];
        draggingNode.style.borderRadius = themeVariables["border-radius-base"];
        draggingNode.style.position = "absolute";
        draggingNode.style.top = "0px";
        draggingNode.style.zIndex = "-1";
        document.body.appendChild(draggingNode);
        e.dataTransfer.setDragImage(draggingNode, 0, 0);
    }
};
export const onDragEnd = () => {
    (draggingNode === null || draggingNode === void 0 ? void 0 : draggingNode.isConnected) && document.body.removeChild(draggingNode);
};
